import { User, Privileges } from 'types';
import { PermissionCheck } from '../types';
import { createNegateVariants } from './createNegateVariants';
import { createPermission } from './createPermission';

// Создает функцию проверки привилегий на основе привилегии пользователя
function createPrivilegesPermission(privilege: Privileges): PermissionCheck {
  return createPermission((user: User) => user.Privileges.includes(privilege));
}

const baseCan = {
  createDevice: createPrivilegesPermission('createDevice'),
  createAnyDevice: createPrivilegesPermission('createAnyDevice'),
  manageHWT: createPrivilegesPermission('manageHwt'),
  updateHWTPaymentDate: createPrivilegesPermission(
    'manageHwt:updatePaymentDate'
  ),
  updateUser: createPrivilegesPermission('updateUser'),
  updateDeviceInfo: createPrivilegesPermission('updateDeviceInfo'),
  updateAnyDeviceInfo: createPrivilegesPermission('updateAnyDeviceInfo'),
  readAnyDevice: createPrivilegesPermission('readAnyDevice'),
  updateBillingBalance: createPrivilegesPermission('billing:updateBalance')
};

export const can = {
  ...baseCan,
  not: createNegateVariants(baseCan)
};
